import { render } from "./CockUpSettings.vue?vue&type=template&id=84118354"
import script from "./CockUpSettings.vue?vue&type=script&lang=js"
export * from "./CockUpSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__